import { render, staticRenderFns } from "./DetailGroupPanel.vue?vue&type=template&id=23e0725e&scoped=true&"
import script from "./DetailGroupPanel.vue?vue&type=script&lang=ts&"
export * from "./DetailGroupPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DetailGroupPanel.vue?vue&type=style&index=0&id=23e0725e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0725e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VChip})
